import { createSlice } from "@reduxjs/toolkit";

const rewardPointSlice = createSlice({
    name: "rewardPoint",
    initialState: {
        rewardPointUnitId: null,
    },
    reducers: {
        setRewardPointUnitId: (state, action) => {
            state.rewardPointUnitId = action.payload;
        },
        clearRewardPointUnitId: (state) => {
            state.rewardPointUnitId = null;
        },
    },
});

export const { setRewardPointUnitId, clearRewardPointUnitId } = rewardPointSlice.actions;
export default rewardPointSlice.reducer;
